import styled from 'styled-components'

export const ContentNavbar = styled.div`
  > div {
    > div {
      display: grid;
      grid-template-columns: 1fr auto 1fr;

      > :nth-child(1) {
        justify-content: flex-start;
      }

      > :nth-child(3) {
        justify-content: flex-end;
      }
    }
  }
`
